<template>
  <avs-card noTitle>
    <template v-slot:content>
      <v-card-text
        ><v-alert
          class="mt-8"
          color="secondary"
          type="info"
          outlined
        >
          <div>{{ $t("commons.in_order_to_export") }}</div>
        </v-alert>
        <v-row>
          <v-col md="4">
            <avs-button
              block
              color="success white--text"
              class="mt-4"
              :disabled="isSignedByUser"
              noSpantext
              @click="sign"
            >
              <template v-slot:name>
                {{ $t("commons.sign") }}
              </template>
            </avs-button>
          </v-col>
          <v-col md="4">
            <avs-button
              block
              color="blue white--text"
              class="mt-4"
              :disabled="isClosed"
              noSpantext
              @click="handleConfirm"
            >
              <template v-slot:name>
                {{ $t("commons.cloture") }}
              </template>
            </avs-button>
          </v-col>
          <v-col md="4">
            <avs-button
              block
              outlined
              class="mt-4"
              noSpantext
              @click="handleClose"
            >
              <template v-slot:name>
                {{ $t("commons.save") }}
              </template>
            </avs-button>
          </v-col>
        </v-row>

        <AvsList dense>
          <v-list-item
            v-for="(item, index) in signatures"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon>mdi-account</v-icon>
                {{ item.user.email }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-icon>mdi-calendar-blank</v-icon>
                {{ item.date }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </AvsList>

        <input
          v-show="false"
          type="file"
          accept="image/*"
          ref="uploadInput"
          @change="handleChange"
        />
        <avs-deleteDialog
          v-model="deleteDialogIsOpen"
          @cancel="handleCancel"
          @delete="handleDelete"
          resource="signature picture"
        />
      </v-card-text>
    </template>
  </avs-card>
</template>

<script>
import { NonConformityService } from "@/services"
import { imageValidator } from "@/utils/validator"

export default {
  name: "NonConformitySign",
  components: {
    AvsList: () => import("@/components/generics/general/AvsList.vue")
    // PicturePreview: () => import("./NonConformityPicturePreview.vue")/
  },
  props: {
    nonConformity: {
      type: Object,
      required: true
    },
    isClosed: {
      type: Boolean,
      default: false
    },
    signatures: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // isCompleted() {
    //   return this.missing === 0
    // },
    isSignedByUser() {
      const currentUser = this.$store.state.app.user
      return this.signatures.findIndex(e => e.user.id === currentUser.id) > -1
    }
  },
  data() {
    return {
      disabled: true,
      pictures: [],
      deleteDialogIsOpen: false,
      selectedItem: {}
    }
  },
  methods: {
    sign() {
      if (this.pictures.length > 0) {
        // Préparez les données de l'image (supposons que vous voulez envoyer la première image)
        const imageData = this.pictures[0].file_url
        // Appelez la fonction post avec l'ID du document et les données de l'image
        NonConformityService.postSignature(this.nonConformity.id, imageData)
          .then(r => {
            NonConformityService.getSignatures(this.nonConformity.id).then(v => {
              this.$emit("input", v)
              this.$emit("success", true)
              this.$emit("disableParent")
            })
          })
          .catch(e => {
            if (e.response && e.response.status === 403) {
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            } else {
              this.$emit("error", e)
            }
          })
      } else {
        // Si aucune image, appelez simplement la fonction post avec l'ID du document
        NonConformityService.postSignature(this.nonConformity.id)
          .then(r => {
            NonConformityService.getSignatures(this.nonConformity.id).then(v => {
              this.$emit("input", v)
              this.$emit("success", true)
              this.$emit("disableParent")
            })
          })
          .catch(e => {
            if (e.response && e.response.status === 403) {
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            } else {
              this.$emit("error", e)
            }
          })
      }
    },
    handleUpload() {
      this.$refs.uploadInput.click()
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete() {
      let f = this.selectedItem.item
      let i = this.selectedItem.indice
      if (f.id && f.unassigned === true) {
        this.pictures.splice(i, 1)
      }
      if (f.id && f.unassigned === undefined) {
        f.removed = true
      } else this.pictures = this.pictures.filter(p => p !== f)

      this.$store.commit("app/message", {
        msg: this.$t("messages.information.signature"),
        color: "success"
      })

      // this.$emit("input", this.pictures)
      this.deleteDialogIsOpen = false
    },
    handleConfirm() {
      this.$emit("confirm")
    },
    handleChange(e) {
      // const $ = this
      const self = this
      const files = Array.from(e.target.files)
      // alert(e.target.files)
      files.forEach((picture, i) => {
        if (imageValidator(picture)) {
          let reader = new FileReader()

          reader.addEventListener(
            "load",
            () => {
              self.pictures.push({
                file_url: reader.result,
                label: "",
                hover: false,
                removed: false
              })
              self.$nextTick(() => {
                // self.$emit("input", this.document.id)
              })
            },
            false
          )
          reader.readAsDataURL(picture)
        }
      })
    },
    handleOpenDeleteDialog(f, i) {
      this.deleteDialogIsOpen = true
      this.selectedItem = { item: f, indice: i }
    },
    handleClose() {
      this.$emit("cancel")
    }
  }
}
</script>
